import * as ModuleLoaderAmd from '@feature-hub/module-loader-amd';

import {
  definedExternals as _definedExternals,
  providedExternals as _providedExternals,
} from '@oneaudi/integrator-shared/externals';

export const definedExternals = {
  ..._definedExternals,
  '@feature-hub/module-loader-amd': ModuleLoaderAmd,
};

export const providedExternals = {
  ..._providedExternals,
  '@feature-hub/module-loader-amd': process.env.FEATURE_HUB_VERSION as string,
};
